// extracted by mini-css-extract-plugin
export default {"container":"MainWrapper_container__jE8a0","btnContainer":"MainWrapper_btnContainer__iP8RH","animationRoll":"MainWrapper_animationRoll__K3dfe"};